export const STORE_INFO = {
  name: "Persi Materiais de Construção",
  address: {
    line: "Rua Itirapina, 163, Vila Lacerda, Jundiaí - SP",
    postcode: "13214-065",
    query: "Rua Itirapina, 163, Vila Lacerda, Jundiaí - SP, 13214-065",
  },
  whatsapp: {
    href: "https://wa.me/551139648294",
    label: "(11) 3964-8294",
  },
  phone: {
    href: "tel:+5511996340689",
    label: "(11) 99634-0689",
  },
  email: {
    href: "mailto:vendas@persimateriais.com.br",
    label: "vendas@persimateriais.com.br",
  },
  hours: {
    weekdays: "Segunda a sexta: 7h30 às 18h",
    saturday: "Sábado: 7h30 às 14h",
  },
} as const;
